module.exports = __webpack_public_path__ + "static/media/JD Homepage-09_cc-09.f3c8e0c0.svg";